import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import BestRoundupLawyersWrapper from "@components/layouts/bestrounduplawyersWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <BestRoundupLawyersWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#3D71E8" />
                </div>
                <FormSection iconsFillColor="#3D71E8" />
            </div>
        </BestRoundupLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
